import { DestroyRef, Directive, EffectRef, effect, inject, Injector, input, runInInjectionContext, untracked } from "@angular/core";
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

@Directive({
    selector: '[minValue]',
    providers: [{ provide: NG_VALIDATORS, useExisting: MinValueValidatorDirective, multi: true }],
    standalone: true
})

export class MinValueValidatorDirective implements Validator {
    readonly minValue = input<number | Date>(undefined);

    private readonly destroyRef = inject(DestroyRef);
    private readonly injector = inject(Injector);
    private validatorDepsEffect?: EffectRef;

    constructor() {
        this.destroyRef.onDestroy(() => this.validatorDepsEffect?.destroy());
    }

    registerOnValidatorChange(fn: () => void): void {
        this.validatorDepsEffect?.destroy();
        runInInjectionContext(this.injector, () => {
            this.validatorDepsEffect = effect(() => {
                this.minValue();
                untracked(() => fn());
            });
        });
    }

    validate(control: AbstractControl): ValidationErrors | null {
        const controlValueExists: boolean = control.value !== null && control.value !== undefined;
        const minValue = this.minValue();
        const maxValueProvided: boolean = minValue !== null && minValue !== undefined;
        const error: ValidationErrors = controlValueExists && maxValueProvided && control.value < this.minValue()
            ? { "min": `Number cannot be less than ${this.minValue()}` }
            : null;
        return error;
    }
}
